export var GroupchatFlow;
(function (GroupchatFlow) {
    GroupchatFlow["GET_GROUPCHATS"] = "GetGroupchats";
})(GroupchatFlow || (GroupchatFlow = {}));
export var DefinitionSizeCategory;
(function (DefinitionSizeCategory) {
    DefinitionSizeCategory["MINIMAL"] = "minimal";
    DefinitionSizeCategory["LOW"] = "low";
    DefinitionSizeCategory["MID"] = "mid";
    DefinitionSizeCategory["HIGH"] = "high";
    DefinitionSizeCategory["VERY_HIGH"] = "very";
})(DefinitionSizeCategory || (DefinitionSizeCategory = {}));
